import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AgentPicker } from "@/components/AgentPicker";
import { toast } from "sonner";
import { Upload } from "lucide-react";

const TEMPLATE = "Name,Business,Phone,Email,Address,City,State,Zip,License Type,License #,Notes\nJane Builder,Builder Co LLC,4075550100,jane@example.com,1 Main St,Orlando,FL,32801,CGC,CGC000000,\n";

export const SuretyLeadImport = ({ onDone, agents }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [agentId, setAgentId] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const template = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([TEMPLATE], { type: "text/csv" }));
    a.download = "contractor-leads-template.csv"; a.click();
  };
  const upload = async () => {
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("agent_id", agentId);
    try { const { data } = await api.post("/surety/leads/import", fd); setRes(data); toast.success(`${data.added} leads added`); onDone?.(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const close = (v) => { setOpen(v); if (!v) { setRes(null); setFile(null); } };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="surety-import-btn"><Upload className="mr-1.5 h-4 w-4" />Upload spreadsheet</Button>
      <Dialog open={open} onOpenChange={close}>
        <DialogContent data-testid="surety-import-dialog">
          <DialogHeader><DialogTitle>Upload a spreadsheet of contractors</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">CSV or Excel (.xlsx), first row = column headers. Recognised columns: Name (or First/Last Name), Business, Phone, Email, Address, City, State, Zip, License Type, License #, Notes. Duplicates are allowed. Up to 5,000 rows.</p>
          <Button variant="link" className="h-auto justify-start p-0 text-sm" onClick={template} data-testid="surety-import-template">Download a template</Button>
          {agents && <AgentPicker agents={agents} value={agentId} onChange={setAgentId} testId="surety-import-agent" />}
          <input type="file" accept=".csv,.xlsx,.xlsm,.txt" onChange={(e) => setFile(e.target.files[0] || null)} className="text-sm" data-testid="surety-import-file" />
          {res && (
            <div className="rounded-md bg-slate-50 p-3 text-sm" data-testid="surety-import-result">
              <div className="font-semibold text-emerald-700">{res.added} leads added{res.skipped_count ? `, ${res.skipped_count} rows skipped` : ""}</div>
              {res.skipped.slice(0, 8).map((s) => <div key={s.row} className="text-xs text-slate-600">Row {s.row}: {s.reason}</div>)}
              {res.truncated && <div className="text-xs text-amber-700">Only the first 5,000 rows were read.</div>}
            </div>
          )}
          <DialogFooter><Button onClick={upload} disabled={!file || busy || (agents && !agentId)} data-testid="surety-import-upload">{busy ? "Uploading..." : "Add leads"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
